export const RANKING_STRATEGIES = {
  CUMULATIVE_SOLVE_TIME: 'CUMULATIVE_SOLVE_TIME',
  MOST_RECENT_SCORE_TIME: 'MOST_RECENT_SCORE_TIME',
} as const;

export type RankingStrategyType = (typeof RANKING_STRATEGIES)[keyof typeof RANKING_STRATEGIES];
